import type { ProtocolState } from "../types/ProtocolState";
import * as protocolService from "../protocol.service";
import { AuthorizationService } from "@/Login/services";

export const getProtocolStoreInitialState = (): ProtocolState => ({
  conversation: [],
  chatSessionID: undefined,
  askingQuestion: false,
  sendingFeedback: false,
  currentCaseId: undefined,
  shouldShowEmtLevel: !protocolService.getEmtLevel?.(AuthorizationService.getUser()),
});
